/* eslint-disable no-unused-expressions */
import React from 'react';
import './ManageBlock.css';
//import {toast} from 'react-toastify';
import {store} from '../../Redux/Store/Store';
import {connect} from 'react-redux';
import {Link} from 'react-router-dom';
import * as actionsBlock from '../../Redux/Actions/Blocks';
import * as httpService from '../HttpService/HttpService';
import * as PropertyBucket from '../../Properties/Properties.js';
import * as validator from '../Validators/ControlValidator.js';
import {BlockDto} from '../Dtos/BlockDto';
import {Waiter} from '.././WaitingSign/Waiting';
import PopUp from '.././PopUp/PopUp';
import Input from '../Input/Input';
import TableCustomLazyLoading from "../TableCustom/TableCustomLazyLoading";

class SearchBlock extends React.Component {

	constructor(props, size) {
		super(props);
		this.editWindow = React.createRef();
		this.state = {
			violations: null,
			editedBlockName: '',
			disabled: false,
			isWaiting: false,
			showPopup: false,
			showEdit: false,
			showEditTab: false,
			showDeactivateTab: false,
			showQuestListTab: false,
			showDeleteTab: false,
			blockId: null,
			questionsData: null,
			classesName: [],
			orderById: "",
			orderDirection: "asc",
			pageSize: 10,
			pageNumber: 0,
			filters: [],
			quickSearch: "",
			columns: [
				{title: 'Kod bloku', field: 'blockId', width: 140},
				{title: 'Tytuł bloku', field: 'name', minWidth: 240, maxWidth: 400},
				{title: 'Aktywny', field: 'activeString', width: 160}
			]
		};
		this.handleClosePopUp = this.handleClosePopUp.bind(this);
		this.changeActivationBlock = this.changeActivationBlock.bind(this);

	}

	columnMap = new Map([
		[0, 'blockId'],
		[1, 'name'],
		[2, 'activeString']
	]);

	handleClosePopUp() {
		this.setState({showPopup: false});

	}

	componentDidMount() {
		document.title = "e-Kontrole | Zarządzaj blokami";
		const {fetchBlocksData} = this.props;
		fetchBlocksData(this.state.pageSize, this.state.pageNumber, this.state.filters, this.state.quickSearch);
	}

	handleChange = (e) => {
		this.props.tableData(e);
	};

	isWaitingOnOff = (OnOff) => {
		this.setState({
			isWaiting: OnOff
		})
	};

	showActionsWindow = (row) => {
		return (
			<PopUp
				customContent
				handleClosePopup={() => this.closeEditTab()}
				title="Edycja bloku"
			>
				<>{this.state.showEditTab ? this.displayEditTab() : null}</>
			</PopUp>
		)
	};

	showEditTab = () => {
		this.setState({
			showEditTab: true,
		});
	};

	showPopup = (title, notification, type) => {
		this.setState({
			showPopup: true,
			popUp: {title: title, notification: notification, type: type}
		})

	};

	displayEditTab = () => {
		let row = this.state.record;
		return (
			<div id='editWindowTab'>
				<Input
					defaultValue={row.blockId}
					inputId='blockCode'
					label='Kod bloku'
					name='blockCode'
					disabled={true}
				/>
				<Input
					onChange={(e) => this.setState({ editedBlockName: e.target.value, violations: null }) }
					defaultValue={row.name}
					inputId='blockName'
					label='Tytuł bloku'
					name='blockName'
					errorId='nameAlert'
					chartsCount={this.state.editedBlockName.length}
					maxLength={500}
					invalid={this.state.violations}
				/>
				{this.state.violations && <p id='nameAlert' className="error-text name-error" role='alert'>{this.state.violations[0]}</p>}
				<div className='btn_group'>
					<button className='btn save-btn' id='saveNewQuestBtn'
						onClick={() => this.saveEditBlock(this.state.record)}>Zapisz<span className='sr-only'> blok</span>
					</button>
					<button className='btn cancel-btn' id='cancelBtn' onClick={() => this.closeEditTab()}>Anuluj</button>
				</div>
			</div>
		);
	};

	getQuestList = (questions) => {
		let questListItems;
		if (questions.length > 0) {
			let questionsItems = questions.map((question) => <li key={question.questionId}>{question.question}</li>);
			questListItems = <div>
				<ol style={{wordBreak: 'break-all', overflowWrap: 'break-word'}} className='mr-2 my-3'>{questionsItems}</ol>
			</div>
		} else {
			questListItems = <p className='mt-4 mb-5'>Brak pytań w bloku</p>;
		}

		return questListItems;
	};

	displayQuestListTab = (row) => {
		let blockId = row.id;
		let url = PropertyBucket.getStandardQuestionsByBlock(blockId);
		let callPromise = httpService.getServicePromise(url, 'GET');
		let _this = this;
		callPromise.then(
			function (questionList) {
				_this.setState({
					showPopup: true,
					record: row,
					popUp: {
						title: 'Lista pytań stałych',
						notification: _this.getQuestList(questionList)
					}
				})
			},
			function (error) {
				_this.isWaitingOnOff(false);
				_this.showPopup('Błąd', error, 'error')
			}
		)
	};

	changeActivationBlock = (record) => {
		let _this = this;
		let blockId = record.id;
		let url = PropertyBucket.urlChangeActivationBlock(blockId);
		let messageActive;

		let blockDto = new BlockDto();
		blockDto.blockId = blockId;
		if (record.active === true) {
			blockDto.active = false;
			messageActive = PropertyBucket.getDeactivateBlockMessage();
		} else {
			blockDto.active = true;
			messageActive = PropertyBucket.getActivateBlockMessage();
		}

		this.isWaitingOnOff(true);

		let callPromise = httpService.getServicePromise(url, 'PUT', blockDto);


		callPromise.then(
			function (message) {
				_this.props.fetchBlocksData(_this.state.pageSize, _this.state.pageNumber, _this.state.filters, _this.state.quickSearch);
				_this.isWaitingOnOff(false);
				_this.showPopup('Komunikat', messageActive, 'notify')
			},
			function (error) {
				_this.isWaitingOnOff(false);
				_this.showPopup('Błąd', error, 'error')
			}
		)
	};

	handleAlertBorder = (validated, className, newClasses, areAllFieldsPassed) => {
		if (validated) {
			let index = newClasses.indexOf('alertBorder');
			areAllFieldsPassed ? areAllFieldsPassed = true : null;
			if (index !== -1) {
				newClasses.splice(index, 1);
				this.setState({[className]: newClasses});
			}
		} else {
			areAllFieldsPassed = false;
			if (!newClasses.includes('alertBorder')) {
				newClasses.push('alertBorder');
			}
			this.setState({[className]: newClasses})
		}
		return areAllFieldsPassed;
	};

	saveEditBlock = (record) => {
		let areAllFieldsPassed = true;
		let name = document.querySelector('#editWindowTab #blockName').value;

		let isNameValidated = validator.getMustBeChecked(name, 'nameAlert', PropertyBucket.getBlockNameMustBeChosen());
		let isNameLongEnough = validator.getMustBeLongEnough(name, 'nameAlert', PropertyBucket.tooLongTextMessage(500), 500);
		areAllFieldsPassed = this.handleAlertBorder(isNameValidated && isNameLongEnough, 'classesName', this.state.classesName, areAllFieldsPassed);

		let _this = this;
		if (areAllFieldsPassed) {
			this.isWaitingOnOff(true);
			let blockId = record.id;
			let url = PropertyBucket.urlEditBlock(blockId);

			let blockDto = new BlockDto();
			blockDto.blockId = blockId;

			blockDto.name = name;

			let callPromise = httpService.getServiceWithSupportErrors(url, 'PUT', blockDto);

			callPromise.then(
				function (message) {
					if (message.violations) {
						_this.setState({
							violations: (message.violations.length > 0 ? message.violations?.map(v => {
								return v.violation + '. '
							}) : null),
						});
						_this.isWaitingOnOff(false);
					} else {
						_this.props.fetchBlocksData(_this.state.pageSize, _this.state.pageNumber, _this.state.filters, _this.state.quickSearch);
						_this.closeEditTab();
						_this.isWaitingOnOff(false);
						_this.showPopup('Komunikat', PropertyBucket.getCreateBlockMessage(), 'notify')
					}
				},
				function (error) {
					_this.isWaitingOnOff(false);
					_this.showPopup('Błąd', error, 'error')
				}
			)
		}
	};

	closeEditTab = () => {
		this.setState({
			showEditTab: false,
			showEdit: false,
			violations: null,
		});
	};


	handleCloseQuest = () => {
		this.setState({showEdit: false});
	};

	onEditButtonClick = (row) => {
		this.setState({
			showEdit: true,
			record: row,
			editedBlockName: row.name,
		});
		this.showEditTab();
	};

	onDeactivateButtonClick = (row) => {
		this.setState({
			showPopup: true,
			record: row,
			popUp: {
				title: 'Zmiana statusu',
				notification: row.active === true ? 'Czy chcesz dezaktywować blok ' + row.blockId + '?' : 'Czy chcesz aktywować blok ' + row.blockId + '?',
				type: 'confirm',
				onClickEvent: () => {
					this.changeActivationBlock(this.state.record)
				}
			}
		})
	};

	onQuestionListButtonClick = (row) => {
		this.displayQuestListTab(row);
	};

	getActiveString = (item) => {
		item.active === true ? item.activeString = 'Tak' : item.activeString = 'Nie';
		return item;
	};

	prepareBlockData = (data) => {

		if(!data) {
			return [];
		}

		return data.map(this.getActiveString);
	};

	handleFilterChange = (filter) => {
		const keyValuePairs = filter.map(f => Object.values(f));
	
		const filters = keyValuePairs
		  .filter(([property, value]) => property && value !== undefined && value !== '')
		  .map(([property, value]) => ({
			property: property,
			value,
			condition: "Contains",
		  }));

		const pageSize = 10;
		const pageNumber = 0;

		this.setState({...this.state, filters, pageSize, pageNumber});
		  
		const { fetchBlocksData } = this.props;

		fetchBlocksData(pageSize, pageNumber, filters, undefined, this.state.quickSearch);
	};

	handleQuickSearchChange(search) {
		const { fetchBlocksData } = this.props;

		this.setState({
			quickSearch: search,
			pageNumber: 0
		});

		fetchBlocksData(this.state.pageSize, 0, this.state.filters, undefined, search);
	}

	render() {
		let loadedBlocksData = store.getState().blocks.blocks;
		let popUp;
		let table;
		if (this.props.blocks.isError === true) {
			this.isWaitingOnOff(false);
			this.showPopup('Błąd', this.props.blocks.error, 'error')
		}
		this.state.showPopup ?
			(popUp = <PopUp type={this.state.popUp.type}
			                title={this.state.popUp.title}
			                notification={this.state.popUp.notification}
			                link={this.state.popUp.link}
			                onClickEvent={this.state.popUp.onClickEvent}
											closePopUp={this.handleClosePopUp}
			/>) : null;


		if (!store.getState().blocks.isLoading) {

			table = <TableCustomLazyLoading
				columns={this.state.columns}
				data={this.prepareBlockData(loadedBlocksData.data)}
				page={this.state.pageNumber}
				pageSize={this.state.pageSize}
				orderBy={this.state.orderById}
				orderDirection={this.state.orderDirection}
				count={loadedBlocksData.totalElements}
				actions={[
					rowData => ({
						icon: 'editButton',
						iconProps: { style: { fontSize: '24px', color: '#0d47a1' } },
						tooltip: <span>Edytuj blok<span className='sr-only'> o nazwie: {rowData.name || ''}</span></span>,
						onClick: (event, rowData) => {
							this.onEditButtonClick(rowData);
						},
					}),
					rowData => ({
						icon: 'autorenew',
						iconProps: { style: { fontSize: '24px', color: '#0d47a1' } },
						tooltip: <span>Zmień status<span className='sr-only'> o nazwie: {rowData.name || ''}</span></span>,
						onClick: (event, rowData) => {
							this.onDeactivateButtonClick(rowData);
						},
					}),
					rowData => ({
						icon: 'list',
						iconProps: { style: { fontSize: '24px', color: '#0d47a1' } },
						tooltip: <span>Podgląd pytań<span className='sr-only'> o nazwie: {rowData.name || ''}</span></span>,
						onClick: (event, rowData) => {
							this.onQuestionListButtonClick(rowData);
						},
					}),
				]}
				initialPage={this.props.match.params.pageNumber ? parseInt(this.props.match.params.pageNumber) - 1 : 0}
				onFilterChange={this.handleFilterChange}
				onOrderChange={(column, order) => {
					this.setState({...this.state, orderById: column, orderDirection: order});

					const {fetchBlocksData} = this.props;
					fetchBlocksData(this.state.pageSize, this.state.pageNumber, this.state.filters, {index: this.columnMap.get(column), direction: order}, this.state.quickSearch);
				}}
				onChangeRowsPerPage={(pageSize) => {
					this.setState({ ...this.state, pageSize: pageSize });

					const {fetchBlocksData} = this.props;
					fetchBlocksData(pageSize, this.state.pageNumber, this.state.filters, undefined, this.state.quickSearch);
				}}
				onChangePage={(page, size) => {
					this.setState({ ...this.state, pageSize: size, pageNumber: page });
					const { fetchBlocksData } = this.props;
					fetchBlocksData(size, page, this.state.filters, undefined, this.state.quickSearch);
				}}
				onQuickSearchChange={(value) => {
					this.handleQuickSearchChange(value)
				}}
				quickSearch={this.state.quickSearch}
			/>;
		}

		return (
			<div id='block_search'>
				{this.state.showEdit ? this.showActionsWindow() : null}
				{popUp}
				<div id='add_block'>
					<h2 className='mb-4 float-left'>Bloki</h2>
					<Link to='/create_block' className='btn save-btn' id='plus_img_container'><i data-v-db6946bc=''
					                                                                             aria-hidden='true'
					                                                                             className='v-icon material-icons theme--light v-list-text'>add</i><span>UTWÓRZ BLOK</span></Link>
					<div className='clearfix'/>
				</div>


				<div id='block_table'>
					{table}
				</div>
				<div id='waiter'><Waiter loading={this.state.isWaiting || this.props.blocks.isLoading}/></div>
			</div>
		)
	}
}

const mapStateToProps = (state) => {
	return state;
};

const mapDispatchToProps = (dispatch) => {
	return {
		fetchBlocksData: (pageSize, pageNumber, filters = [], sorting = {}, quickSearch = "") => dispatch(actionsBlock.getDataPaged(pageSize, pageNumber, filters, sorting, quickSearch))
	}
};

export const SearchBlockProvider = connect(mapStateToProps, mapDispatchToProps)(SearchBlock);





